module.exports = __webpack_public_path__ + "static/img/11.0241492.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/11.png
// module id = kBjE
// module chunks = 0